export const ENERGY_PRICE_COLOR_SCHEMES = {
	/** Multi-stop Verivox orange with warmer highlight toward the top-left. */
	scheme1:
		'linear-gradient(125deg, #FF9A4A 0%, #FF7A1A 22%, #FF6A00 48%, #E64600 78%, #C93A00 100%)',
} as const;

/** Text colour for white CTA buttons on the Verivox orange gradient. */
export const ENERGY_PRICE_CTA_TEXT_COLOR = '#E64600';

/** Public path to the Verivox wordmark/logo asset. */
export const VERIVOX_LOGO_SRC = './images/verivox-logo.png';

export type ColorSchemeKey = keyof typeof ENERGY_PRICE_COLOR_SCHEMES;

const STORAGE_KEY = 'shelly_energy_price_color_scheme';

export const energyPriceColorSchemes = {
	schemes: ENERGY_PRICE_COLOR_SCHEMES,

	getCurrentScheme(): ColorSchemeKey {
		try {
			const saved = localStorage.getItem(STORAGE_KEY);
			if (saved && saved in ENERGY_PRICE_COLOR_SCHEMES) {
				return saved as ColorSchemeKey;
			}
		} catch (err) {
			console.error('Failed to read color scheme from localStorage:', err);
		}
		return 'scheme1';
	},

	setCurrentScheme(scheme: ColorSchemeKey): void {
		try {
			localStorage.setItem(STORAGE_KEY, scheme);
		} catch (err) {
			console.error('Failed to save color scheme to localStorage:', err);
		}
	},
};
